export default __webpack_public_path__ + "static/media/imal.0f7c5e11.jpg";